module.exports = __webpack_public_path__ + "static/img/autodesk.564c8bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/autodesk.png
// module id = ZAe6
// module chunks = 53